
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

$parcel$export(module.exports, "ForgeContentTools", () => $0c33e41081c1500e$export$7cf22b806dbb23cb);
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $7QUD1 = parcelRequire("7QUD1");
var $7Ndnw = parcelRequire("7Ndnw");
var $8a9Dm = parcelRequire("8a9Dm");
var $hIaUw = parcelRequire("hIaUw");
var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $6UqI3 = parcelRequire("6UqI3");
var $6uUjl = parcelRequire("6uUjl");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");

var $3jwuS = parcelRequire("3jwuS");

var $041p6 = parcelRequire("041p6");

var $9MrOn = parcelRequire("9MrOn");
const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $gwFzn.useState)(null);
    const [isLoading, setLoading] = (0, $gwFzn.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $gwFzn.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $gwFzn.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $gwFzn.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $gwFzn.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]); // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $gwFzn.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9MrOn.ContentToolsButton), {
                isLoading: true // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                ,
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, undefined, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $dIouf.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $041p6.ForgeContentToolsItem), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const onInitialRender = (0, $gwFzn.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: onClose,
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};

});
parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("dVuk7"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("XSJTh"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("hwfiK"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("36vrF"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("aza77"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("fZyCQ"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("eZ7vW"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("6ejCE"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("30LMm"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("5bqjM"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("cWXXZ"))).PageBannerForgeApp
});

});
parcelRegister("dVuk7", function(module, exports) {

let $a2381eda598a91cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $a2381eda598a91cc$var$load("7Q0UC"),
    $a2381eda598a91cc$var$load("hf7yW"),
    $a2381eda598a91cc$var$load("lU1wr"),
    $a2381eda598a91cc$var$load("29wqP"),
    $a2381eda598a91cc$var$load("lnKog"),
    $a2381eda598a91cc$var$load("2aE9V"),
    $a2381eda598a91cc$var$load("iQ0Jm"),
    $a2381eda598a91cc$var$load("9L8th"),
    $a2381eda598a91cc$var$load("daCl8"),
    $a2381eda598a91cc$var$load("gQSWJ"),
    $a2381eda598a91cc$var$load("1c4TZ"),
    $a2381eda598a91cc$var$load("cplyI"),
    $a2381eda598a91cc$var$load("aOkrq"),
    $a2381eda598a91cc$var$load("3L8bY"),
    $a2381eda598a91cc$var$load("7VwsU"),
    $a2381eda598a91cc$var$load("fsZ6i"),
    $a2381eda598a91cc$var$load("3689E"),
    $a2381eda598a91cc$var$load("g1XVY"),
    $a2381eda598a91cc$var$load("keSaw"),
    $a2381eda598a91cc$var$load("9fG7I"),
    $a2381eda598a91cc$var$load("gwAWX"),
    $a2381eda598a91cc$var$load("h4Nf7"),
    $a2381eda598a91cc$var$load("6ZgMI"),
    $a2381eda598a91cc$var$load("9FBaW"),
    $a2381eda598a91cc$var$load("6StWh"),
    $a2381eda598a91cc$var$load("g9CVe"),
    $a2381eda598a91cc$var$load("YUxKy"),
    $a2381eda598a91cc$var$load("4aLlP"),
    $a2381eda598a91cc$var$load("6gqpV"),
    $a2381eda598a91cc$var$load("aZinD"),
    $a2381eda598a91cc$var$load("4Pn6Z"),
    $a2381eda598a91cc$var$load("6qah4"),
    $a2381eda598a91cc$var$load("c6MKV"),
    $a2381eda598a91cc$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("XSJTh", function(module, exports) {

let $0b3ff8dc99bdd027$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0b3ff8dc99bdd027$var$load("7Q0UC"),
    $0b3ff8dc99bdd027$var$load("hf7yW"),
    $0b3ff8dc99bdd027$var$load("lU1wr"),
    $0b3ff8dc99bdd027$var$load("29wqP"),
    $0b3ff8dc99bdd027$var$load("lnKog"),
    $0b3ff8dc99bdd027$var$load("2aE9V"),
    $0b3ff8dc99bdd027$var$load("iQ0Jm"),
    $0b3ff8dc99bdd027$var$load("9L8th"),
    $0b3ff8dc99bdd027$var$load("daCl8"),
    $0b3ff8dc99bdd027$var$load("gQSWJ"),
    $0b3ff8dc99bdd027$var$load("1c4TZ"),
    $0b3ff8dc99bdd027$var$load("cplyI"),
    $0b3ff8dc99bdd027$var$load("aOkrq"),
    $0b3ff8dc99bdd027$var$load("3L8bY"),
    $0b3ff8dc99bdd027$var$load("7VwsU"),
    $0b3ff8dc99bdd027$var$load("fsZ6i"),
    $0b3ff8dc99bdd027$var$load("3689E"),
    $0b3ff8dc99bdd027$var$load("g1XVY"),
    $0b3ff8dc99bdd027$var$load("keSaw"),
    $0b3ff8dc99bdd027$var$load("9fG7I"),
    $0b3ff8dc99bdd027$var$load("gwAWX"),
    $0b3ff8dc99bdd027$var$load("h4Nf7"),
    $0b3ff8dc99bdd027$var$load("6ZgMI"),
    $0b3ff8dc99bdd027$var$load("9FBaW"),
    $0b3ff8dc99bdd027$var$load("6StWh"),
    $0b3ff8dc99bdd027$var$load("g9CVe"),
    $0b3ff8dc99bdd027$var$load("YUxKy"),
    $0b3ff8dc99bdd027$var$load("4aLlP"),
    $0b3ff8dc99bdd027$var$load("6gqpV"),
    $0b3ff8dc99bdd027$var$load("aZinD"),
    $0b3ff8dc99bdd027$var$load("4Pn6Z"),
    $0b3ff8dc99bdd027$var$load("6qah4"),
    $0b3ff8dc99bdd027$var$load("c6MKV"),
    $0b3ff8dc99bdd027$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("hwfiK", function(module, exports) {

let $cc114b5b5e5ab153$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $cc114b5b5e5ab153$var$load("7Q0UC"),
    $cc114b5b5e5ab153$var$load("hf7yW"),
    $cc114b5b5e5ab153$var$load("lU1wr"),
    $cc114b5b5e5ab153$var$load("29wqP"),
    $cc114b5b5e5ab153$var$load("lnKog"),
    $cc114b5b5e5ab153$var$load("2aE9V"),
    $cc114b5b5e5ab153$var$load("iQ0Jm"),
    $cc114b5b5e5ab153$var$load("9L8th"),
    $cc114b5b5e5ab153$var$load("daCl8"),
    $cc114b5b5e5ab153$var$load("gQSWJ"),
    $cc114b5b5e5ab153$var$load("1c4TZ"),
    $cc114b5b5e5ab153$var$load("cplyI"),
    $cc114b5b5e5ab153$var$load("aOkrq"),
    $cc114b5b5e5ab153$var$load("3L8bY"),
    $cc114b5b5e5ab153$var$load("7VwsU"),
    $cc114b5b5e5ab153$var$load("fsZ6i"),
    $cc114b5b5e5ab153$var$load("3689E"),
    $cc114b5b5e5ab153$var$load("g1XVY"),
    $cc114b5b5e5ab153$var$load("keSaw"),
    $cc114b5b5e5ab153$var$load("9fG7I"),
    $cc114b5b5e5ab153$var$load("gwAWX"),
    $cc114b5b5e5ab153$var$load("h4Nf7"),
    $cc114b5b5e5ab153$var$load("6ZgMI"),
    $cc114b5b5e5ab153$var$load("9FBaW"),
    $cc114b5b5e5ab153$var$load("6StWh"),
    $cc114b5b5e5ab153$var$load("g9CVe"),
    $cc114b5b5e5ab153$var$load("YUxKy"),
    $cc114b5b5e5ab153$var$load("4aLlP"),
    $cc114b5b5e5ab153$var$load("6gqpV"),
    $cc114b5b5e5ab153$var$load("aZinD"),
    $cc114b5b5e5ab153$var$load("4Pn6Z"),
    $cc114b5b5e5ab153$var$load("6qah4"),
    $cc114b5b5e5ab153$var$load("c6MKV"),
    $cc114b5b5e5ab153$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("36vrF", function(module, exports) {

let $242a53023aee7089$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $242a53023aee7089$var$load("9L8th"),
    $242a53023aee7089$var$load("aOkrq"),
    $242a53023aee7089$var$load("3L8bY"),
    $242a53023aee7089$var$load("7VwsU"),
    $242a53023aee7089$var$load("fsZ6i"),
    $242a53023aee7089$var$load("3689E"),
    $242a53023aee7089$var$load("g1XVY"),
    $242a53023aee7089$var$load("keSaw"),
    $242a53023aee7089$var$load("9fG7I"),
    $242a53023aee7089$var$load("gwAWX"),
    $242a53023aee7089$var$load("h4Nf7"),
    $242a53023aee7089$var$load("6ZgMI"),
    $242a53023aee7089$var$load("9FBaW"),
    $242a53023aee7089$var$load("6StWh"),
    $242a53023aee7089$var$load("g9CVe"),
    $242a53023aee7089$var$load("6qah4"),
    $242a53023aee7089$var$load("YUxKy"),
    $242a53023aee7089$var$load("6gqpV"),
    $242a53023aee7089$var$load("aZinD"),
    $242a53023aee7089$var$load("4Pn6Z"),
    $242a53023aee7089$var$load("c6MKV"),
    $242a53023aee7089$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("aza77", function(module, exports) {

let $7b1504a7290d60b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7b1504a7290d60b5$var$load("9L8th"),
    $7b1504a7290d60b5$var$load("aOkrq"),
    $7b1504a7290d60b5$var$load("3L8bY"),
    $7b1504a7290d60b5$var$load("7VwsU"),
    $7b1504a7290d60b5$var$load("fsZ6i"),
    $7b1504a7290d60b5$var$load("3689E"),
    $7b1504a7290d60b5$var$load("g1XVY"),
    $7b1504a7290d60b5$var$load("keSaw"),
    $7b1504a7290d60b5$var$load("9fG7I"),
    $7b1504a7290d60b5$var$load("gwAWX"),
    $7b1504a7290d60b5$var$load("h4Nf7"),
    $7b1504a7290d60b5$var$load("6ZgMI"),
    $7b1504a7290d60b5$var$load("9FBaW"),
    $7b1504a7290d60b5$var$load("6StWh"),
    $7b1504a7290d60b5$var$load("g9CVe"),
    $7b1504a7290d60b5$var$load("6qah4"),
    $7b1504a7290d60b5$var$load("YUxKy"),
    $7b1504a7290d60b5$var$load("6gqpV"),
    $7b1504a7290d60b5$var$load("aZinD"),
    $7b1504a7290d60b5$var$load("4Pn6Z"),
    $7b1504a7290d60b5$var$load("c6MKV"),
    $7b1504a7290d60b5$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("fZyCQ", function(module, exports) {

let $ba47696fbf259700$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ba47696fbf259700$var$load("lU1wr"),
    $ba47696fbf259700$var$load("29wqP"),
    $ba47696fbf259700$var$load("lnKog"),
    $ba47696fbf259700$var$load("9L8th"),
    $ba47696fbf259700$var$load("aOkrq"),
    $ba47696fbf259700$var$load("3L8bY"),
    $ba47696fbf259700$var$load("7VwsU"),
    $ba47696fbf259700$var$load("fsZ6i"),
    $ba47696fbf259700$var$load("3689E"),
    $ba47696fbf259700$var$load("g1XVY"),
    $ba47696fbf259700$var$load("keSaw"),
    $ba47696fbf259700$var$load("9fG7I"),
    $ba47696fbf259700$var$load("gwAWX"),
    $ba47696fbf259700$var$load("h4Nf7"),
    $ba47696fbf259700$var$load("6ZgMI"),
    $ba47696fbf259700$var$load("9FBaW"),
    $ba47696fbf259700$var$load("6StWh"),
    $ba47696fbf259700$var$load("g9CVe"),
    $ba47696fbf259700$var$load("6qah4"),
    $ba47696fbf259700$var$load("YUxKy"),
    $ba47696fbf259700$var$load("6gqpV"),
    $ba47696fbf259700$var$load("aZinD"),
    $ba47696fbf259700$var$load("4Pn6Z"),
    $ba47696fbf259700$var$load("c6MKV"),
    $ba47696fbf259700$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("eZ7vW", function(module, exports) {

let $ae8c975be7733ebb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ae8c975be7733ebb$var$load("7Q0UC"),
    $ae8c975be7733ebb$var$load("lU1wr"),
    $ae8c975be7733ebb$var$load("29wqP"),
    $ae8c975be7733ebb$var$load("lnKog"),
    $ae8c975be7733ebb$var$load("9L8th"),
    $ae8c975be7733ebb$var$load("1c4TZ"),
    $ae8c975be7733ebb$var$load("cplyI"),
    $ae8c975be7733ebb$var$load("aOkrq"),
    $ae8c975be7733ebb$var$load("3L8bY"),
    $ae8c975be7733ebb$var$load("7VwsU"),
    $ae8c975be7733ebb$var$load("fsZ6i"),
    $ae8c975be7733ebb$var$load("3689E"),
    $ae8c975be7733ebb$var$load("g1XVY"),
    $ae8c975be7733ebb$var$load("keSaw"),
    $ae8c975be7733ebb$var$load("9fG7I"),
    $ae8c975be7733ebb$var$load("gwAWX"),
    $ae8c975be7733ebb$var$load("h4Nf7"),
    $ae8c975be7733ebb$var$load("6ZgMI"),
    $ae8c975be7733ebb$var$load("dTsOE"),
    $ae8c975be7733ebb$var$load("9FBaW"),
    $ae8c975be7733ebb$var$load("6StWh"),
    $ae8c975be7733ebb$var$load("g9CVe"),
    $ae8c975be7733ebb$var$load("6qah4"),
    $ae8c975be7733ebb$var$load("YUxKy"),
    $ae8c975be7733ebb$var$load("4aLlP"),
    $ae8c975be7733ebb$var$load("6gqpV"),
    $ae8c975be7733ebb$var$load("aZinD"),
    $ae8c975be7733ebb$var$load("4Pn6Z"),
    $ae8c975be7733ebb$var$load("c6MKV"),
    $ae8c975be7733ebb$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("6ejCE", function(module, exports) {

let $489345815b72a31d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $489345815b72a31d$var$load("7Q0UC"),
    $489345815b72a31d$var$load("lU1wr"),
    $489345815b72a31d$var$load("29wqP"),
    $489345815b72a31d$var$load("lnKog"),
    $489345815b72a31d$var$load("9L8th"),
    $489345815b72a31d$var$load("1c4TZ"),
    $489345815b72a31d$var$load("cplyI"),
    $489345815b72a31d$var$load("aOkrq"),
    $489345815b72a31d$var$load("3L8bY"),
    $489345815b72a31d$var$load("7VwsU"),
    $489345815b72a31d$var$load("fsZ6i"),
    $489345815b72a31d$var$load("3689E"),
    $489345815b72a31d$var$load("g1XVY"),
    $489345815b72a31d$var$load("keSaw"),
    $489345815b72a31d$var$load("9fG7I"),
    $489345815b72a31d$var$load("gwAWX"),
    $489345815b72a31d$var$load("h4Nf7"),
    $489345815b72a31d$var$load("6ZgMI"),
    $489345815b72a31d$var$load("dTsOE"),
    $489345815b72a31d$var$load("9FBaW"),
    $489345815b72a31d$var$load("6StWh"),
    $489345815b72a31d$var$load("g9CVe"),
    $489345815b72a31d$var$load("6qah4"),
    $489345815b72a31d$var$load("YUxKy"),
    $489345815b72a31d$var$load("4aLlP"),
    $489345815b72a31d$var$load("6gqpV"),
    $489345815b72a31d$var$load("aZinD"),
    $489345815b72a31d$var$load("4Pn6Z"),
    $489345815b72a31d$var$load("c6MKV"),
    $489345815b72a31d$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("30LMm", function(module, exports) {

let $23166f1b6acd525a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $23166f1b6acd525a$var$load("9L8th"),
    $23166f1b6acd525a$var$load("aOkrq"),
    $23166f1b6acd525a$var$load("3L8bY"),
    $23166f1b6acd525a$var$load("7VwsU"),
    $23166f1b6acd525a$var$load("fsZ6i"),
    $23166f1b6acd525a$var$load("3689E"),
    $23166f1b6acd525a$var$load("g1XVY"),
    $23166f1b6acd525a$var$load("keSaw"),
    $23166f1b6acd525a$var$load("9fG7I"),
    $23166f1b6acd525a$var$load("gwAWX"),
    $23166f1b6acd525a$var$load("h4Nf7"),
    $23166f1b6acd525a$var$load("6ZgMI"),
    $23166f1b6acd525a$var$load("9FBaW"),
    $23166f1b6acd525a$var$load("6StWh"),
    $23166f1b6acd525a$var$load("g9CVe"),
    $23166f1b6acd525a$var$load("6qah4"),
    $23166f1b6acd525a$var$load("YUxKy"),
    $23166f1b6acd525a$var$load("6gqpV"),
    $23166f1b6acd525a$var$load("aZinD"),
    $23166f1b6acd525a$var$load("4Pn6Z"),
    $23166f1b6acd525a$var$load("c6MKV"),
    $23166f1b6acd525a$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("5bqjM", function(module, exports) {

let $3c62650d02bb6706$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3c62650d02bb6706$var$load("lU1wr"),
    $3c62650d02bb6706$var$load("29wqP"),
    $3c62650d02bb6706$var$load("lnKog"),
    $3c62650d02bb6706$var$load("9L8th"),
    $3c62650d02bb6706$var$load("aOkrq"),
    $3c62650d02bb6706$var$load("3L8bY"),
    $3c62650d02bb6706$var$load("7VwsU"),
    $3c62650d02bb6706$var$load("fsZ6i"),
    $3c62650d02bb6706$var$load("3689E"),
    $3c62650d02bb6706$var$load("g1XVY"),
    $3c62650d02bb6706$var$load("keSaw"),
    $3c62650d02bb6706$var$load("9fG7I"),
    $3c62650d02bb6706$var$load("gwAWX"),
    $3c62650d02bb6706$var$load("h4Nf7"),
    $3c62650d02bb6706$var$load("6ZgMI"),
    $3c62650d02bb6706$var$load("9FBaW"),
    $3c62650d02bb6706$var$load("6StWh"),
    $3c62650d02bb6706$var$load("g9CVe"),
    $3c62650d02bb6706$var$load("6qah4"),
    $3c62650d02bb6706$var$load("YUxKy"),
    $3c62650d02bb6706$var$load("6gqpV"),
    $3c62650d02bb6706$var$load("aZinD"),
    $3c62650d02bb6706$var$load("4Pn6Z"),
    $3c62650d02bb6706$var$load("c6MKV"),
    $3c62650d02bb6706$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("cWXXZ", function(module, exports) {

let $96d96aec2787d64d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $96d96aec2787d64d$var$load("lU1wr"),
    $96d96aec2787d64d$var$load("29wqP"),
    $96d96aec2787d64d$var$load("lnKog"),
    $96d96aec2787d64d$var$load("9L8th"),
    $96d96aec2787d64d$var$load("aOkrq"),
    $96d96aec2787d64d$var$load("3L8bY"),
    $96d96aec2787d64d$var$load("7VwsU"),
    $96d96aec2787d64d$var$load("fsZ6i"),
    $96d96aec2787d64d$var$load("3689E"),
    $96d96aec2787d64d$var$load("g1XVY"),
    $96d96aec2787d64d$var$load("keSaw"),
    $96d96aec2787d64d$var$load("9fG7I"),
    $96d96aec2787d64d$var$load("gwAWX"),
    $96d96aec2787d64d$var$load("h4Nf7"),
    $96d96aec2787d64d$var$load("6ZgMI"),
    $96d96aec2787d64d$var$load("9FBaW"),
    $96d96aec2787d64d$var$load("6StWh"),
    $96d96aec2787d64d$var$load("g9CVe"),
    $96d96aec2787d64d$var$load("6qah4"),
    $96d96aec2787d64d$var$load("YUxKy"),
    $96d96aec2787d64d$var$load("6gqpV"),
    $96d96aec2787d64d$var$load("aZinD"),
    $96d96aec2787d64d$var$load("4Pn6Z"),
    $96d96aec2787d64d$var$load("c6MKV"),
    $96d96aec2787d64d$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("dizL5", function(module, exports) {

$parcel$export(module.exports, "lazyForgeUIExtensionsWithLoader", () => $55b20ed34f146485$export$350b371bfb7f5e95);
$parcel$export(module.exports, "LazyForgeUIExtensions", () => $55b20ed34f146485$export$4cbc6d03d50a8849);

var $jmjWc = parcelRequire("jmjWc");

const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("bHqPo"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);

});
parcelRegister("bHqPo", function(module, exports) {

let $8848855577ab5b06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8848855577ab5b06$var$load("lU1wr"),
    $8848855577ab5b06$var$load("29wqP"),
    $8848855577ab5b06$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


parcelRegister("6UqI3", function(module, exports) {

$parcel$export(module.exports, "getSpaceType", () => $a3c7cd489159fe33$export$28eddf802cd184f7);
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};

});

parcelRegister("041p6", function(module, exports) {

$parcel$export(module.exports, "ForgeContentToolsItem", () => $ced39bfea5ef5993$export$9f275aff884e1431);
/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $9hlns = parcelRequire("9hlns");

var $9fBoq = parcelRequire("9fBoq");

var $al4VD = parcelRequire("al4VD");
const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz131l" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $gwFzn.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired
};

});
parcelRegister("9fBoq", function(module, exports) {

$parcel$export(module.exports, "extensionTitle", () => $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e);

var $1c598 = parcelRequire("1c598");
const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1c598.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1c598.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};

});


parcelRegister("9MrOn", function(module, exports) {

$parcel$export(module.exports, "ContentToolsButton", () => $43c0d8bb08806c39$export$f221d384e5b0f4c3);
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9VJDA = parcelRequire("9VJDA");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $blsJs = parcelRequire("blsJs");

var $j8UzL = parcelRequire("j8UzL");
const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $2nPZH.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isLoading: isLoading, preloadCopyItem: preloadCopyItem, preloadMoveItem: preloadMoveItem, isExternalCollaborator: isExternalCollaborator = false })=>{
    const intl = (0, $dBxQj.default)();
    const [showSpinner, setSpinner] = (0, $gwFzn.useState)(false);
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $gwFzn.useState)('auto');
    const dropdownMenuContainerRef = (0, $gwFzn.useRef)(null);
    (0, $blsJs.useSubmitSSRScriptErrors)('page-more-action-button');
    const isMoreActionButtonClickedInSSR = ()=>Boolean(window.__SSR_EVENTS_CAPTURE__?.moreActionButton && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        (window.__SSR_RENDERED__ || undefined));
    const handleOnOpenChange = (obj)=>{
        if (window.__SSR_RENDERED__ && isLoading) {
            if (!window.__SSR_EVENTS_CAPTURE__) window.__SSR_EVENTS_CAPTURE__ = {};
            window.__SSR_EVENTS_CAPTURE__.moreActionButton = true;
            setSpinner(true);
        }
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        const handleButton = async ()=>{
            if (isMoreActionButtonClickedInSSR()) {
                if (!isLoading) {
                    await preloadCopyItem?.();
                    await preloadMoveItem?.();
                    handleOnOpenChange({
                        isOpen: true
                    });
                    setSpinner(false);
                    delete window.__SSR_EVENTS_CAPTURE__?.moreActionButton;
                } else //if clicked in SSR, gotta show spinner even when SPA takes over while loading
                setSpinner(true);
            }
        };
        handleButton(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoading
    ]);
    if (isMoreActionButtonClickedInSSR() && showSpinner) {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        const SSR_ACTION_LOADING_SPINNER_STYLE = {
            marginLeft: '10px'
        };
        return /*#__PURE__*/ $gwFzn.createElement((0, $j8UzL.SSRActionLoadingSpinner), {
            spinnerId: "more-action-loading-spinner",
            actionType: "moreActionButton",
            showSpinner: true // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ,
            styleOverride: SSR_ACTION_LOADING_SPINNER_STYLE
        });
    }
    return /*#__PURE__*/ $gwFzn.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $35pXk.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $gwFzn.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $gwFzn.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $gwFzn.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    preloadCopyItem: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    preloadMoveItem: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $gwFzn.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);

});
parcelRegister("blsJs", function(module, exports) {

$parcel$export(module.exports, "useSubmitSSRScriptErrors", () => $7bdb5572ed9c8600$export$290a00987d4ffd42);

var $gwFzn = parcelRequire("gwFzn");

var $5ZqQS = parcelRequire("5ZqQS");
const $7bdb5572ed9c8600$export$290a00987d4ffd42 = (scope)=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!window.__SSR_CLIENT_ERRORS__ || !window.__SSR_CLIENT_ERRORS__[scope]) return;
        const ssrErrors = window.__SSR_CLIENT_ERRORS__[scope];
        ssrErrors.forEach((error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone'
            }));
        delete window.__SSR_CLIENT_ERRORS__[scope];
    }, [
        scope
    ]);
};

});



parcelRegister("c4sKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3633338e39044437$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5dK2X = parcelRequire("5dK2X");

var $exYql = parcelRequire("exYql");
const $3633338e39044437$var$boxStyles = {
    root: "_2rkopd34 _18zr12x7 _1e0c116y _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i",
    default: "_bfhkm7j4",
    important: "_bfhkybec",
    primary: "_bfhkb29m",
    primaryInverted: "_bfhkvuon",
    removed: "_bfhk1gly"
};
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $3633338e39044437$var$neutral300 = '#DDDEE1';
const $3633338e39044437$var$red300 = '#FD9891';
const $3633338e39044437$var$blue300 = '#8FB8F6';
const $3633338e39044437$var$neutral1000 = '#292A2E';
const $3633338e39044437$var$styles = {
    root: "_2rkogqwt _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i _syaz1fxt",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1e6v",
    removed: "_bfhk1gly _syaz1fxt"
};
const $3633338e39044437$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    // Use this flag for allowing negative values(numbers) in badge component when custom number field is used
    if ((0, $dh538.fg)('platform_ken_2029_negative_numbers_badge')) return typeof children === 'number' && typeof max === 'number' ? (0, $exYql.formatValueWithNegativeSupport)(children, max) : children;
    return typeof children === 'number' && max ? (0, $exYql.formatValue)(children, max) : children;
}; /**
    * __Badge__
    *
    * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
    *
    * - [Examples](https://atlassian.design/components/badge/examples)
    * - [Code](https://atlassian.design/components/badge/code)
    * - [Usage](https://atlassian.design/components/badge/usage)
    */ 
const $3633338e39044437$var$Badge = /*#__PURE__*/ (0, $gwFzn.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $35pXk.default)([
            $3633338e39044437$var$styles.root,
            $3633338e39044437$var$styles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            backgroundColor: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $35pXk.default)([
            $3633338e39044437$var$boxStyles.root,
            $3633338e39044437$var$boxStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $3633338e39044437$var$textColors[appearance],
            children: $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
$3633338e39044437$var$Badge.displayName = 'Badge';
var $3633338e39044437$export$2e2bcd8739ae039 = $3633338e39044437$var$Badge;
const $3633338e39044437$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("exYql", function(module, exports) {

$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $1687c74e524fbc98$export$4b844743568d5983);
$parcel$export(module.exports, "formatValue", () => $1687c74e524fbc98$export$7c4d25c0c3217d8c);
function $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $1687c74e524fbc98$export$4b844743568d5983(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $1687c74e524fbc98$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $1687c74e524fbc98$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValue(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("3uVVG", function(module, exports) {

$parcel$export(module.exports, "auth", () => $81514351a4f15f99$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("uvNb9")).AuthError);

var $uvNb9 = parcelRequire("uvNb9");

var $9P47v = parcelRequire("9P47v");
function $81514351a4f15f99$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $9P47v.isOfTypeAuthError)(errorType)) reject(new (0, $uvNb9.AuthError)(data.message, errorType));
                    else reject(new (0, $uvNb9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $uvNb9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("uvNb9", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $2c5766e42a4da15d$export$145273558d58e0ac);
class $2c5766e42a4da15d$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("9P47v", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $cd3cb472abe3f4ba$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $cd3cb472abe3f4ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});



//# sourceMappingURL=ForgeContentTools.1b802ca3.js.map
